export default __webpack_public_path__ + "static/media/aq.42e79631.svg";